export const hiddenPasswordPattern = '************************';